var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 720,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 721,
	"./assets/thewest-digital-hero-variation-a.jpg": 2605,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 722,
	"./assets/thewest-digital-hero-variation-b.jpg": 2606,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 723,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2607,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 724,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2608,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 725,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2609,
	"./assets/thewest-digital-hero.jpg": 2610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2604;